import type { RubriqueCode } from "@/types/silae";

// Données des codes de rubriques organisées par catégorie
export const RUBRIQUE_CODES: Record<string, RubriqueCode[]> = {
  autres_rémunérations: [
    {
      code: "K01",
      label: "Allocation de formation DIF (hors temps de travail)",
      description: "Allocation de formation DIF (hors temps de travail)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K02",
      label: "Allocation de préretraite",
      description: "Allocation de préretraite",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K02.1",
      label: "Allocation viagère de retraite",
      description: "Allocation viagère de retraite",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K03",
      label: "Pension d'invalidité",
      description: "Pension d'invalidité",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K04",
      label: "Contribution patronale exo/chèques vacances ",
      description: "Contribution patronale exo/ch�ques vacances ",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K05",
      label: "Part salariale chèques vacances",
      description: "Part salariale chèques vacances",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K06",
      label: "Saisie sur salaire",
      description: "Saisie sur salaire",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K07",
      label: "Impôt à la source",
      description: "Impôt à la source",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K08",
      label: "Contribution patronale chèques-vacances (autres entreprises)",
      description:
        "Contribution patronale ch�ques-vacances (autres entreprises)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "K09",
      label: "Prime d'intéressement bloquée",
      description: "Prime d'intéressement bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K09.1",
      label: "Prime d'intéressement bloquée",
      description: "Prime d'intéressement bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K09.2",
      label: "Prime d'intéressement bloquée",
      description: "Prime d'intéressement bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K09.3",
      label: "Prime d'intéressement bloquée",
      description: "Prime d'intéressement bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K09.4",
      label: "Prime d'intéressement bloquée",
      description: "Prime d'intéressement bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10",
      label: "Prime d'intéressement/participation versée",
      description: "Prime d'intéressement/participation versée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10.1",
      label: "Prime d'intéressement/participation versée 2",
      description: "Prime d'intéressement/participation versée 2",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10.2",
      label: "Prime d'intéressement/participation versée 3",
      description: "Prime d'intéressement/participation versée 3",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10.3",
      label: "Prime d'intéressement/participation versée",
      description: "Prime d'intéressement/participation versée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10.4",
      label: "Prime d'intéressement/participation versée",
      description: "Prime d'intéressement/participation versée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K10.5",
      label: "Prime d'intéressement/participation versée",
      description: "Prime d'intéressement/participation versée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11.1",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11.2",
      label: "Dépassement abondement de l'entreprise /",
      description: "Dépassement abondement de l'entreprise /",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K11.3",
      label: "Abondement non exonéré de l'entreprise /",
      description: "Abondement non exonéré de l'entreprise /",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11.4",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11.5",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K11.6",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K11.7",
      label: "Abondement de l'entreprise / Plan d'épargne",
      description: "Abondement de l'entreprise / Plan d'épargne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K12",
      label: "Participation au financement des services à la personne",
      description: "Participation au financement des services à la personne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K12.1",
      label: "Participation au financement des services à la personne",
      description: "Participation au financement des services à la personne",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K13",
      label: "Allocation de formation hors temps de travail (imposable)",
      description: "Allocation de formation hors temps de travail (imposable)",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.1",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.10",
      label: "Prime d'intéressement",
      description: "Prime d'intéressement",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.11",
      label: "Prime de participation",
      description: "Prime de participation",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.12",
      label: "Prime d'intéressement",
      description: "Prime d'intéressement",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.13",
      label: "Prime de participation",
      description: "Prime de participation",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.14",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.15",
      label: "Prime d'intéressement bloqué",
      description: "Prime d'intéressement bloqué",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.2",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.3",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.4",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.5",
      label: "Prime de participation bloquée",
      description: "Prime de participation bloquée",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.6",
      label: "Abondement au plan d'épargne entreprise (PEE)",
      description: "Abondement au plan d'épargne entreprise (PEE)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.7",
      label: "Abondement au plan d'épargne entreprise (PEI)",
      description: "Abondement au plan d'épargne entreprise (PEI)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.8",
      label: "Abondement au plan d'épargne entreprise (PER)",
      description: "Abondement au plan d'épargne entreprise (PER)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K14.9",
      label: "Prime de participation",
      description: "Prime de participation",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K15",
      label: "Prime dividendes",
      description: "Prime dividendes",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K16",
      label: "Régularisation sur net fiscal",
      description: "Régularisation sur net fiscal",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K17",
      label: "Revenus de location-gérance",
      description: "Revenus de location-gérance",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "K18",
      label: "Régularisation sur le net à payer",
      description: "Régularisation sur le net à payer",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K19",
      label: "Avantages en espèces à réintégrer",
      description: "Avantages en espèces à réintégrer",
      category: "Autres Rémunérations",
      properties: { imposable: false, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "K19.1",
      label: "Avantages en espèces à réintégrer",
      description: "Avantages en espèces à réintégrer",
      category: "Autres Rémunérations",
      properties: { imposable: false, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "K19.2",
      label: "Avantages en espèces à réintégrer",
      description: "Avantages en espèces à réintégrer",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "K19.3",
      label: "Avantages en espèces à réintégrer",
      description: "Avantages en espèces à réintégrer",
      category: "Autres Rémunérations",
      properties: { imposable: false, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "K19.4",
      label: "Avantages en espèces à réintégrer",
      description: "Avantages en espèces à réintégrer",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "K20",
      label: "Jetons de présence",
      description: "Jetons de présence",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K21",
      label: "Jetons de présence Administrateurs",
      description: "Jetons de présence Administrateurs",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K21.1",
      label: "Indemnités versées aux administrateurs MSA",
      description: "Indemnités versées aux administrateurs MSA",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K21.2",
      label: "Indemnités versées aux administrateurs non salarié",
      description: "Indemnités versées aux administrateurs non salarié",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K21.3",
      label: "Indemnités versées aux administrateurs régime général",
      description: "Indemnités versées aux administrateurs régime général",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K22",
      label: "Versement de jours de CP sur PERCO/art. 83 (sans CET)",
      description: "Versement de jours de CP sur PERCO/art. 83 (sans CET)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "K22.1",
      label:
        "Versement de jours de CP sur PERCO/art. 83 (sans CET) (imposable)",
      description:
        "Versement de jours de CP sur PERCO/art. 83 (sans CET) (imposable)",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K23",
      label: "Attribution d'actions gratuites",
      description: "Attribution d'actions gratuites",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K24",
      label: "Bons d'achat exonérés",
      description: "Bons d'achat exonérés",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K24.1",
      label: "Bons d'achat non exonérés",
      description: "Bons d'achat non exonérés",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K24.2",
      label: "Bons d'achat exonérés (hors événements tolérés)",
      description: "Bons d'achat exonérés (hors événements tolérés)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K24.3",
      label: "Bons d'achat non exonérés (hors événements tolérés)",
      description: "Bons d'achat non exonérés (hors événements tolérés)",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K24.4",
      label: "Bons d'achat non exonérés (à déduire)",
      description: "Bons d'achat non exonérés (à déduire)",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K25",
      label: "Bonus exceptionnel DOM",
      description: "Bonus exceptionnel DOM",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K26",
      label: "Médaille d'honneur du travail",
      description: "Médaille d'honneur du travail",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K26.1",
      label: "Médaille du travail [soumise / imposable]",
      description: "Médaille du travail [soumise / imposable]",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K27",
      label:
        '"Frais &quot;art. 700 du code de procédure civile&quot;""art. 700 du code de proc�dure civile"""',
      description:
        '"Frais &quot;art. 700 du code de procédure civile&quot;""art. 700 du code de proc�dure civile"""',
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K28",
      label: "Gratification versée à un salarié extérieur",
      description: "Gratification versée à un salarié extérieur",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K29",
      label: "Allocation de reclassement (hors préavis)",
      description: "Allocation de reclassement (hors préavis)",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K30",
      label: "Droit voisin",
      description: "Droit voisin",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K31",
      label: "Royalties artistes/mannequins",
      description: "Royalties artistes/mannequins",
      category: "Autres Rémunérations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "K31.1",
      label: "Royalties artistes/mannequins",
      description: "Royalties artistes/mannequins",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K32",
      label: "Rémunération maintenue mobilité",
      description: "Rémunération maintenue mobilité",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K34",
      label: "Rémunération membres conseil de surveillance",
      description: "Rémunération membres conseil de surveillance",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K35",
      label: "Bourse de l'Etat",
      description: "Bourse de l'Etat",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K36",
      label: "Indemnité de coordination",
      description: "Indemnité de coordination",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K37",
      label: "Chèque Santé",
      description: "Chèque Santé",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K38",
      label: "Pourboires non centralisés à retenir",
      description: "Pourboires non centralisés à retenir",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K39",
      label: "Versement direct sur",
      description: "Versement direct sur",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K39.1",
      label: "Versement indirect sur",
      description: "Versement indirect sur",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K39.2",
      label: "Versement direct sur",
      description: "Versement direct sur",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K40",
      label: "Indemnité de 5% (MC)",
      description: "Indemnité de 5% (MC)",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K41",
      label: "Consignation salaire des - 16 ans",
      description: "Consignation salaire des - 16 ans",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K42",
      label: "Prime exceptionnelle de pouvoir d'achat",
      description: "Prime exceptionnelle de pouvoir d'achat",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K43",
      label: "Prime exceptionnelle Covid-19",
      description: "Prime exceptionnelle Covid-19",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K44",
      label: "Maintien gratuit des garanties (Covid-19)",
      description: "Maintien gratuit des garanties (Covid-19)",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K45",
      label: "Indemnité inflation",
      description: "Indemnité inflation",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K46",
      label: "Remboursement forfaitaire protection sociale",
      description: "Remboursement forfaitaire protection sociale",
      category: "Autres Rémunérations",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K47",
      label: "Montant net social",
      description: "Montant net social",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "K47.1",
      label: "Montant net social",
      description: "Montant net social",
      category: "Autres Rémunérations",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
  ],
  avantages_en_nature: [
    {
      code: "A01",
      label: "AeN nourriture (repas pris)",
      description: "AeN nourriture (repas pris)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A01.1",
      label: "AeN nourriture (repas pris) (uniquement déduit)",
      description: "AeN nourriture (repas pris) (uniquement déduit)",
      category: "Avantages en Nature",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "A01.b",
      label: "AeN nourriture (repas pris)",
      description: "AeN nourriture (repas pris)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A02",
      label: "Indemnité compensatrice de nourriture",
      description: "Indemnité compensatrice de nourriture",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A02.b",
      label: "Indemnité compensatrice de nourriture",
      description: "Indemnité compensatrice de nourriture",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A02.CP",
      label: "Indemnité compensatrice de nourriture",
      description: "Indemnité compensatrice de nourriture",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A02.CPb",
      label: "Indemnité compensatrice de nourriture",
      description: "Indemnité compensatrice de nourriture",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A03",
      label: "Avantages en Nature logement",
      description: "Avantages en Nature logement",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A03.1",
      label: "Avantages en Nature logement (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature logement (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A03.1b",
      label: "Avantages en Nature logement",
      description: "Avantages en Nature logement",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A03.2",
      label: "Avantages en Nature logement (uniquement déduit)",
      description: "Avantages en Nature logement (uniquement déduit)",
      category: "Avantages en Nature",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "A03.3",
      label: "Avantages en Nature logement",
      description: "Avantages en Nature logement",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A03.3b",
      label: "Avantages en Nature logement",
      description: "Avantages en Nature logement",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A03.b",
      label: "Avantages en Nature logement",
      description: "Avantages en Nature logement",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A04",
      label: "Avantages en Nature véhicule",
      description: "Avantages en Nature véhicule",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A04.1",
      label: "Avantages en Nature véhicule (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature v�hicule (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A04.1b",
      label: "Avantages en Nature véhicule (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature v�hicule (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A04.2",
      label: "Avantages en Nature véhicule (uniquement déduit)",
      description: "Avantages en Nature véhicule (uniquement déduit)",
      category: "Avantages en Nature",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "A04.b",
      label: "Avantages en Nature véhicule",
      description: "Avantages en Nature véhicule",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A05",
      label: "Avantages en Nature NTIC",
      description: "Avantages en Nature NTIC",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A05.1",
      label: "Avantages en Nature NTIC (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature NTIC (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A05.1b",
      label: "Avantages en Nature NTIC (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature NTIC (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A05.b",
      label: "Avantages en Nature NTIC",
      description: "Avantages en Nature NTIC",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A06",
      label: "Avantages en Nature Autres",
      description: "Avantages en Nature Autres",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A06.1",
      label: "Avantages en Nature Autres (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature Autres (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A06.1b",
      label: "Avantages en Nature Autres (ne subsistent pas pendant les CP)",
      description:
        "Avantages en Nature Autres (ne subsistent pas pendant les CP)",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "A06.2",
      label: "Avantages en Nature Autres (uniquement déduit)",
      description: "Avantages en Nature Autres (uniquement déduit)",
      category: "Avantages en Nature",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "A06.3",
      label: "Indemnité compensatrice Autres",
      description: "Indemnité compensatrice Autres",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A06.3b",
      label: "Indemnité compensatrice Autres",
      description: "Indemnité compensatrice Autres",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "A06.4",
      label: "Maintien base cotisations/protection sociale",
      description: "Maintien base cotisations/protection sociale",
      category: "Avantages en Nature",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "A06.b",
      label: "Avantages en Nature Autres",
      description: "Avantages en Nature Autres",
      category: "Avantages en Nature",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  frais_professionnels: [
    {
      code: "F01",
      label: "Frais professionnels au forfait (DFS) [non imposable]",
      description: "Frais professionnels au forfait (DFS) [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F02",
      label: "Frais professionnels au réel (DFS) [non imposable]",
      description: "Frais professionnels au réel (DFS) [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F02.1",
      label: "Frais kilométriques dépassant les 7cv",
      description: "Frais kilométriques dépassant les 7cv",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F03",
      label: "Prime transport (DFS) [&lt;=200eur / non imposable]",
      description: "Prime transport (DFS) [&lt;=200eur / non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F04",
      label:
        "Frais de transport domicile-travail (DFS) [&gt;200eur / imposable]",
      description:
        "Frais de transport domicile-travail (DFS) [>200eur / imposable]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F05",
      label: "Frais professionnels au forfait [non imposable]",
      description: "Frais professionnels au forfait [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F05.NV",
      label: "Frais professionnels au forfait (versés hors BS)",
      description: "Frais professionnels au forfait (versés hors BS)",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F06",
      label: "Frais professionnels au réel [non imposable]",
      description: "Frais professionnels au réel [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F06.NV",
      label: "Frais professionnels au réel (versés hors BS)",
      description: "Frais professionnels au réel (versés hors BS)",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F07",
      label: "Remboursement abonnement transport",
      description: "Remboursement abonnement transport",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F07.1",
      label: "Remboursement abonnement transport&gt;50%",
      description: "Remboursement abonnement transport&gt;50%",
      category: "Frais Professionnels",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F07.2",
      label: "Remboursement abonnement transport&gt;50% (DFS)",
      description: "Remboursement abonnement transport&gt;50% (DFS)",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F08",
      label: "Prime transport [&lt;=200eur / non imposable]",
      description: "Prime transport [&lt;=200eur / non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F08.R",
      label: "Prime transport REGION [&lt;=240eur / non imposable]",
      description: "Prime transport REGION [&lt;=240eur / non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F09",
      label: "Frais de transport domicile-travail [&gt;200eur]",
      description: "Frais de transport domicile-travail [&gt;200eur]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F09.R",
      label: "Prime transport REGION [&gt;240eur]",
      description: "Prime transport REGION [&gt;240eur]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F10",
      label: "Remboursement de frais professionnels",
      description: "Remboursement de frais professionnels",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F10.1",
      label: "Prime de salissure",
      description: "Prime de salissure",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F11",
      label: "Indemnité de repas (DFS) [non imposable]",
      description: "Indemnité de repas (DFS) [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F12",
      label: "Indemnité de repas [non imposable]",
      description: "Indemnité de repas [non imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F13",
      label: "Frais professionnels au forfait [cotisations, imposable]",
      description: "Frais professionnels au forfait [cotisations, imposable]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F13.1",
      label: "Frais professionnels au forfait [cotisations, imposable]",
      description: "Frais professionnels au forfait [cotisations, imposable]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F14",
      label: "Frais professionnels au réel (DFS) [imposable]",
      description: "Frais professionnels au réel (DFS) [imposable]",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "F15",
      label: "Frais professionnels au forfait [imposable]",
      description: "Frais professionnels au forfait [imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F16",
      label: "Frais professionnels au réel [imposable]",
      description: "Frais professionnels au réel [imposable]",
      category: "Frais Professionnels",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F17",
      label: "Indemnité de transport (DFS)",
      description: "Indemnité de transport (DFS)",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F18",
      label: "Indemnité de transport",
      description: "Indemnité de transport",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F20",
      label: "Prime d'outillage (DFS)",
      description: "Prime d'outillage (DFS)",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F21",
      label: "Prime d'outillage",
      description: "Prime d'outillage",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F22",
      label: "Indemnités kilométriques domicile-travail",
      description: "Indemnités kilométriques domicile-travail",
      category: "Frais Professionnels",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F23",
      label:
        "Frais professionnels (pris en charge directement par l'employeur)",
      description:
        "Frais professionnels (pris en charge directement par l'employeur)",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F24",
      label: "Indemnité compensatoire de transport Corse contractuel",
      description: "Indemnité compensatoire de transport Corse contractuel",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "F25",
      label: "Indemnité compensatoire de transport Corse non contractuel",
      description: "Indemnité compensatoire de transport Corse non contractuel",
      category: "Frais Professionnels",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "F26",
      label: "Indemnité des syndicats mixtes",
      description: "Indemnité des syndicats mixtes",
      category: "Frais Professionnels",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  indemnités_de_licenciement: [
    {
      code: "J01",
      label: "Indemnité légale ou conventionnelle de licenciement",
      description: "Indemnité légale ou conventionnelle de licenciement",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J01.1",
      label: "Indemnité légale ou conventionnelle de licenciement",
      description: "Indemnité légale ou conventionnelle de licenciement",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "J01.2",
      label: "Indemnité légale ou conventionnelle de licenciement",
      description: "Indemnité légale ou conventionnelle de licenciement",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J02",
      label: "Indemnité de rupture conventionnelle (régime de faveur)",
      description: "Indemnité de rupture conventionnelle (régime de faveur)",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J02.1",
      label: "Indemnité de rupture conventionnelle",
      description: "Indemnité de rupture conventionnelle",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "J02.2",
      label: "Indemnité de rupture conventionnelle",
      description: "Indemnité de rupture conventionnelle",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J02.2012",
      label:
        "Indemnit� de rupture conventionnelle (r�gime de faveur) avant 2012",
      description:
        "Indemnit� de rupture conventionnelle (r�gime de faveur) avant 2012",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J02.3",
      label: "Indemnité de rupture conventionnelle",
      description: "Indemnité de rupture conventionnelle",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J02.4",
      label: "Indemnité de rupture conventionnelle",
      description: "Indemnité de rupture conventionnelle",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J02.5",
      label: "Indemnité de rupture conventionnelle",
      description: "Indemnité de rupture conventionnelle",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J04",
      label: "Indemnité transactionnelle",
      description: "Indemnité transactionnelle",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J04.RC",
      label: "Indemnité transactionnelle",
      description: "Indemnité transactionnelle",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J05",
      label: "Indemnité de mise à la retraite",
      description: "Indemnité de mise à la retraite",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J05.1",
      label: "Indemnité de mise à la retraite",
      description: "Indemnité de mise à la retraite",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "J05.2",
      label: "Indemnité de mise à la retraite",
      description: "Indemnité de mise à la retraite",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J06",
      label: "Indemnité de départ volontaire (PSE)",
      description: "Indemnité de départ volontaire (PSE)",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J07",
      label:
        "Indemnité de rupture conventionnelle (&lt; minimum légal ou conv)",
      description:
        "Indemnit� de rupture conventionnelle (< minimum l�gal ou conv)",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J07.1",
      label: "Indemnité de rupture conventionnelle (non exo)",
      description: "Indemnité de rupture conventionnelle (non exo)",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J07.2012",
      label:
        "Indemnit� de rupture conventionnelle (> minimum l�gal ou conv) av 2012",
      description:
        "Indemnit� de rupture conventionnelle (> minimum l�gal ou conv) av 2012",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J08",
      label: "Dommages et intérÍts",
      description: "Dommages et intérÍts",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "J08.1",
      label: "Dommages et intérÍts non exo",
      description: "Dommages et intérÍts non exo",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J08.2",
      label: "Dommages et intérÍts soumis non imposable",
      description: "Dommages et intérÍts soumis non imposable",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "J09",
      label: "Indemnité transactionnelle",
      description: "Indemnité transactionnelle",
      category: "Indemnités de Licenciement",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "J10",
      label: "Indemnité de conciliation prud'homale",
      description: "Indemnité de conciliation prud'homale",
      category: "Indemnités de Licenciement",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
  ],
  indemnités_de_rupture: [
    {
      code: "I01",
      label: "Indemnité de précarité",
      description: "Indemnité de précarité",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I01.1",
      label: "Indemnité de précarité",
      description: "Indemnité de précarité",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I02",
      label: "Indemnité de rupture anticipée d'un CDD",
      description: "Indemnité de rupture anticipée d'un CDD",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I03",
      label: "Indemnité compensatrice de CP",
      description: "Indemnité compensatrice de CP",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I04",
      label: "Indemnité compensatrice de RTT",
      description: "Indemnité compensatrice de RTT",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I05",
      label: "Indemnité compensatrice de CET",
      description: "Indemnité compensatrice de CET",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I06",
      label: "Indemnité compensatrice de préavis",
      description: "Indemnité compensatrice de préavis",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I06.1",
      label: "Allocation congé de reclassement (sur préavis)",
      description: "Allocation congé de reclassement (sur préavis)",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I06.2",
      label: "Allocation congé de mobilité (sur préavis)",
      description: "Allocation congé de mobilité (sur préavis)",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I07",
      label: "Indemnité de préavis",
      description: "Indemnité de préavis",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I08",
      label: "Indemnité de non-concurrence",
      description: "Indemnité de non-concurrence",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I09",
      label: "Indemnité de départ à la retraite/initiative salarié",
      description: "Indemnité de départ à la retraite/initiative salarié",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I09.PSE",
      label: "Indemnité de départ à la retraite/initiative salarié",
      description: "Indemnité de départ à la retraite/initiative salarié",
      category: "Indemnités de Rupture",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "I10",
      label:
        "Indemnit� compensatrice/inaptitude professionnelle (L.1226-14 CT)",
      description:
        "Indemnit� compensatrice/inaptitude professionnelle (L.1226-14 CT)",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I11",
      label: "Indemnité de départ anticipé 'amiante'",
      description: "Indemnité de départ anticipé 'amiante'",
      category: "Indemnités de Rupture",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "I12",
      label: "Indemnité compensatrice de RC",
      description: "Indemnité compensatrice de RC",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I12.1",
      label: "Indemnité compensatrice de RCR (sans majoration)",
      description: "Indemnité compensatrice de RCR (sans majoration)",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I13",
      label: "Indemnité délai de prévenance",
      description: "Indemnité délai de prévenance",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "I14",
      label: "Indemnité de rupture anticipée CDD (D &amp; I)",
      description: "Indemnité de rupture anticipée CDD (D &amp; I)",
      category: "Indemnités de Rupture",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  majorations: [
    {
      code: "C01",
      label: "Majoration (nuit, dimanche, férié)",
      description: "Majoration (nuit, dimanche, férié)",
      category: "Majorations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "C01.1",
      label: "Majoration (nuit, dimanche, férié) payée pendant les CP",
      description: "Majoration (nuit, dimanche, férié) payée pendant les CP",
      category: "Majorations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "C01.2",
      label: "Majoration (nuit, dimanche, férié) mensualisé",
      description: "Majoration (nuit, dimanche, férié) mensualisé",
      category: "Majorations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "C02",
      label: "Complément différentiel RTT",
      description: "Complément différentiel RTT",
      category: "Majorations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "C03",
      label: "Indemnité différentielle",
      description: "Indemnité différentielle",
      category: "Majorations",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  primes_diverses: [
    {
      code: "D01",
      label: "Prime d'ancienneté",
      description: "Prime d'ancienneté",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D01.1",
      label: "Complément prime d'ancienneté",
      description: "Complément prime d'ancienneté",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D01.EX",
      label: "Prime d'ancienneté",
      description: "Prime d'ancienneté",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D02",
      label: "Prime exceptionnelle",
      description: "Prime exceptionnelle",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D02.CP",
      label: "Prime exceptionnelle (entrant dans la base CP)",
      description: "Prime exceptionnelle (entrant dans la base CP)",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D03",
      label: "Prime d'assiduité",
      description: "Prime d'assiduité",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D03.CP",
      label: "Prime d'assiduité (entrant dans la base CP)",
      description: "Prime d'assiduité (entrant dans la base CP)",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D04",
      label: "Prime de fin d'année",
      description: "Prime de fin d'année",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "D05",
      label: "Prime de 13è mois",
      description: "Prime de 13è mois",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D06",
      label: "Prime de vacances",
      description: "Prime de vacances",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: true },
    },
    {
      code: "D07",
      label: "Prime de polyvalence",
      description: "Prime de polyvalence",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D08",
      label: "Prime de production",
      description: "Prime de production",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D09",
      label: "Prime de rendement individuel prévisible",
      description: "Prime de rendement individuel prévisible",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D11",
      label: "Prime de responsabilité",
      description: "Prime de responsabilité",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D11.CP",
      label: "Prime de responsabilité (entrant dans la base CP)",
      description: "Prime de responsabilité (entrant dans la base CP)",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D12",
      label: "Prime de respect des consignes de sécurité",
      description: "Prime de respect des consignes de sécurité",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D13",
      label: "Prime de déplacement à l'étranger",
      description: "Prime de déplacement à l'étranger",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D14",
      label: "Prime de dépaysement",
      description: "Prime de dépaysement",
      category: "Primes Diverses",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "D15",
      label: "Prime de qualité",
      description: "Prime de qualité",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D16",
      label: "Indemnité de gérant",
      description: "Indemnité de gérant",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "D21",
      label: "Garantie individuelle du pouvoir d'achat",
      description: "Garantie individuelle du pouvoir d'achat",
      category: "Primes Diverses",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  primes_de_résultat: [
    {
      code: "H01",
      label: "Prime de rendement collectif imprévisible",
      description: "Prime de rendement collectif imprévisible",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H02",
      label: "Prime de bilan (caractère individuel)",
      description: "Prime de bilan (caractère individuel)",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H02.1",
      label: "Prime de bilan (caractère collectif)",
      description: "Prime de bilan (caractère collectif)",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H03",
      label: "Prime de résultat (caractère individuel)",
      description: "Prime de résultat (caractère individuel)",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H03.1",
      label: "Prime de résultat (caractère collectif)",
      description: "Prime de résultat (caractère collectif)",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H04",
      label: "Prime à la production",
      description: "Prime à la production",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H05",
      label: "Prime à la productivité",
      description: "Prime à la productivité",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "H08",
      label: "Indemnité activité partielle",
      description: "Indemnité activité partielle",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H08.1",
      label: "Indemnité activité partielle non soumise CGS/RDS",
      description: "Indemnité activité partielle non soumise CGS/RDS",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H09",
      label: "Indemnité chômage partiel CP",
      description: "Indemnité chômage partiel CP",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H10",
      label: "Indemnité chômage intempéries",
      description: "Indemnité chômage intempéries",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H11",
      label: "Indemnité complémentaire RMM",
      description: "Indemnité complémentaire RMM",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H12",
      label: "Indemnité de cherté de vie",
      description: "Indemnité de cherté de vie",
      category: "Primes de Résultat",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "H12.1",
      label: "Indemnité de cherté de vie",
      description: "Indemnité de cherté de vie",
      category: "Primes de Résultat",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  primes_de_sujétion: [
    {
      code: "E01",
      label: "Prime d'amplitude",
      description: "Prime d'amplitude",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E01.1",
      label: "Prime d'amplitude",
      description: "Prime d'amplitude",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E02",
      label: "Prime d'astreinte",
      description: "Prime d'astreinte",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E03",
      label: "Prime de danger",
      description: "Prime de danger",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E04",
      label: "Prime de risque",
      description: "Prime de risque",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E05",
      label: "Prime de froid",
      description: "Prime de froid",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E06",
      label: "Prime d'insalubrité",
      description: "Prime d'insalubrité",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E07",
      label: "Prime de salissure",
      description: "Prime de salissure",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E08",
      label: "Prime de rythme",
      description: "Prime de rythme",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E09",
      label: "Prime de situation géographique",
      description: "Prime de situation géographique",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E10",
      label: "Prime de sous-sol",
      description: "Prime de sous-sol",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E11",
      label: "Prime d'expatriation",
      description: "Prime d'expatriation",
      category: "Primes de Sujétion",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "E12",
      label: "Indemnité d'habillage/déshabillage",
      description: "Indemnité d'habillage/déshabillage",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E12.1",
      label: "Indemnité d'habillage/déshabillage",
      description: "Indemnité d'habillage/déshabillage",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E12.2",
      label: "Indemnité d'habillage/déshabillage",
      description: "Indemnité d'habillage/déshabillage",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E13",
      label: "Indemnité de trajet",
      description: "Indemnité de trajet",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E13.1",
      label: "Indemnité de trajet",
      description: "Indemnité de trajet",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E14",
      label: "Prime d'impatriation (abattement)",
      description: "Prime d'impatriation (abattement)",
      category: "Primes de Sujétion",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "E14.1",
      label: "Prime d'impatriation",
      description: "Prime d'impatriation",
      category: "Primes de Sujétion",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "E15",
      label: "Autre prime de sujétion",
      description: "Autre prime de sujétion",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "E16",
      label: "Indemnité de sujétions particulières - accueillant familial",
      description:
        "Indemnit� de suj�tions particuli�res - accueillant familial",
      category: "Primes de Sujétion",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
  rémunérations_de_base: [
    {
      code: "B01",
      label: "Commissions",
      description:
        "Indemnité de sujétions particulières - accueillant familial",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B01.1",
      label: "Avance sur commissions",
      description: "Avance sur commissions",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B01.2",
      label: "Rémunération variable",
      description: "Rémunération variable",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B01.3",
      label: "Commissions",
      description: "Commissions",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B02",
      label: "Pourboires centralisés",
      description: "Pourboires centralisés",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B02.1",
      label: "Pourboires non centralisés",
      description: "Pourboires non centralisés",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B03",
      label: "Indemnité de Congés payés",
      description: "Indemnité de Congés payés",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B04",
      label: "Rachat exonéré de jours/forfait jours",
      description: "Rachat exonéré de jours/forfait jours",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "B04.1",
      label: "Rachat de jours/forfait jours",
      description: "Rachat de jours/forfait jours",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B05",
      label: "IJ prévoyance (financement employeur)",
      description: "IJ prévoyance (financement employeur)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B05.C",
      label: "IJ prévoyance versée directement au salarié (sans CSG)",
      description: "IJ prévoyance versée directement au salarié (sans CSG)",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "B05.O",
      label: "IJ prévoyance versés directement aux salariés",
      description: "IJ prévoyance versés directement aux salariés",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B05.SD",
      label: "IJ prévoyance versée le mois de l'absence",
      description: "IJ prévoyance versée le mois de l'absence",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B06",
      label: "IJ prévoyance (financement salarié)",
      description: "IJ prévoyance (financement salarié)",
      category: "Rémunérations de Base",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "B06.O",
      label: "IJ prévoyance (financement salarié) peràues/salarié",
      description: "IJ prévoyance (financement salarié) peràues/salarié",
      category: "Rémunérations de Base",
      properties: {
        imposable: true,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "B07",
      label: "IJ prévoyance (financement salarié, adhésion facultative)",
      description: "IJ prévoyance (financement salarié, adhésion facultative)",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "B08",
      label: "Rappel de salaire",
      description: "Rappel de salaire",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B08.1",
      label: "Régularisation d'abattement",
      description: "Régularisation d'abattement",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "B09",
      label: "Indemnité de RTT",
      description: "Indemnité de RTT",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B10",
      label: "Indemnité de RC",
      description: "Indemnité de RC",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B10.1",
      label: "Indemnité de RCR (sans majoration)",
      description: "Indemnité de RCR (sans majoration)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B11",
      label: "Indemnités Journalières de Sécurité Sociale",
      description: "Indemnités Journalières de Sécurité Sociale",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B12",
      label: "Prestation Engagement Service Civique",
      description: "Prestation Engagement Service Civique",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: false,
        base_cp: false,
      },
    },
    {
      code: "B13",
      label: "Prime versée pendant les CP",
      description: "Prime versée pendant les CP",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B14",
      label: "Salaire supplémentaire contractuel",
      description: "Salaire supplémentaire contractuel",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B15",
      label: "Complément sur salaire de base",
      description: "Complément sur salaire de base",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B15.1",
      label: "Complément sur salaire de base (exo)",
      description: "Complément sur salaire de base (exo)",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
    {
      code: "B15.2",
      label: "Complément sur salaire de base (aide au poste)",
      description: "Complément sur salaire de base (aide au poste)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B15.3",
      label: "Complément sur salaire de base",
      description: "Complément sur salaire de base",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B15.4",
      label: "Complément sur salaire de base",
      description: "Complément sur salaire de base",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B16",
      label: "Indemnités complémentaires employeur",
      description: "Indemnités complémentaires employeur",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B16.1",
      label: "Indemnités complémentaires employeur (ajustement/net)",
      description: "Indemnités complémentaires employeur (ajustement/net)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B16.2",
      label: "Indemnités complémentaires employeur (ajustement/net)",
      description: "Indemnités complémentaires employeur (ajustement/net)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B17",
      label: "Prime versée suite à jugement prud'homal",
      description: "Prime versée suite à jugement prud'homal",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B18",
      label: "Supplément familial de traitement",
      description: "Supplément familial de traitement",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B19",
      label: "Indemnité de résidence",
      description: "Indemnité de résidence",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B20",
      label: "Nouvelle bonification indiciaire",
      description: "Nouvelle bonification indiciaire",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B21",
      label: "Neutralisation brut progressif",
      description: "Neutralisation brut progressif",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B22",
      label: "Indemnité de fonction (élus)",
      description: "Indemnité de fonction (élus)",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B23",
      label: "Indemnité d'intermittence",
      description: "Indemnité d'intermittence",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B24",
      label: "Complément fédéral",
      description: "Complément fédéral",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B25",
      label: "Indemnité membre élu",
      description: "Indemnité membre élu",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B26",
      label: "Complément de traitement indiciaire",
      description: "Complément de traitement indiciaire",
      category: "Rémunérations de Base",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
    {
      code: "B99",
      label: "Prime pour calcul de réintégration fiscale",
      description: "Prime pour calcul de réintégration fiscale",
      category: "Rémunérations de Base",
      properties: {
        imposable: false,
        soumis_cotisations: true,
        base_cp: false,
      },
    },
  ],
  événements_familiaux: [
    {
      code: "G01",
      label: "Prime événement familial (mariage, naissance...)",
      description: "Prime événement familial (mariage, naissance...)",
      category: "Événements Familiaux",
      properties: { imposable: true, soumis_cotisations: true, base_cp: false },
    },
  ],
};

// Helper pour obtenir tous les codes triés par label
export const getAllRubriqueCodes = (): RubriqueCode[] => {
  const allCodes = Object.values(RUBRIQUE_CODES).flat();
  return allCodes.sort((a, b) => a.label.localeCompare(b.label));
};

// Helper pour obtenir les noms des catégories avec leurs icônes
export const getCategoryDisplayName = (categoryKey: string): string => {
  const categoryNames: Record<string, string> = {
    autres_rémunérations: "AUTRES RÉMUNÉRATIONS",
    avantages_en_nature: "AVANTAGES EN NATURE",
    frais_professionnels: "FRAIS PROFESSIONNELS",
    indemnités_de_licenciement: "INDEMNITÉS DE LICENCIEMENT",
    indemnités_de_rupture: "INDEMNITÉS DE RUPTURE",
    majorations: "MAJORATIONS",
    primes_diverses: "PRIMES DIVERSES",
    primes_de_résultat: "PRIMES DE RÉSULTAT",
    primes_de_sujétion: "PRIMES DE SUJÉTION",
    rémunérations_de_base: "RÉMUNÉRATIONS DE BASE",
    événements_familiaux: "ÉVÉNEMENTS FAMILIAUX",
  };

  return categoryNames[categoryKey] || categoryKey;
};

// Helper pour obtenir le label d'un code rubrique
export const getRubriqueLabel = (code: string): string => {
  const allCodes = Object.values(RUBRIQUE_CODES).flat();
  const rubrique = allCodes.find((r) => r.code === code);
  return rubrique ? rubrique.label : code;
};
